<button mat-fab aria-label="Help" (click)="toggle()" class="help-button" matTooltip="Nápověda">
  <mat-icon>question_mark</mat-icon>
</button>

<div class="help-card-container" [@slideToggle]="visible ? 'visible' : 'hidden'">
  <mat-card class="help-card">
    <div class="help-card-header">
      Nápověda
      <button mat-icon-button (click)="toggle()" aria-label="Close Help">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="help-card-body">
      <mat-accordion>
        @for (item of help; track item.id) {
          <ng-container>
            <mat-expansion-panel [expanded]="item.page === currentPage">
              <mat-expansion-panel-header>
                <mat-panel-title>{{ item.title }}</mat-panel-title>
              </mat-expansion-panel-header>
              <div #helpContent [innerHTML]="bypassSanitization(item.content)"></div>
            </mat-expansion-panel>
          </ng-container>
        }
      </mat-accordion>
    </div>
  </mat-card>
</div>
